class ReactPreviewSponsorLetter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedRowsCount: 0,
            visible: false,
            templateId: null,
            submit: this.props.submit,
            invalid: false,
            loading: true,
        };
    }

    show(callback)
    {
        var stateObject = {
            visible: true,
            templateId: null,
        };
        if(callback){
            stateObject.submit = callback;
        }
        this.refs['templateId'].clearValue();
        this.setState(stateObject);
    }

    _hide()
    {
        this.setState({
            visible: false
        });
    }

    _save()
    {
        if(this.state.templateId) {
            this.state.submit(this.state.templateId);
            this._hide();
        }else{
            console.log('implement error');
        }
    }

    setTemplateId(value)
    {
        this.setState({
            templateId: value.value
        });
    }

    render()
    {
        let templateField = (
            <FieldDropdown
                ref="templateId"
                name="template_id"
                key="template"
                label="Select letter template"
                idPath={['TemplatePdf', 'id']}
                displayPath={['TemplatePdf', 'name']}
                value={this.state.templateId}
                url={SS.route('Templates', 'TemplatePdfs', 'getForDropdown', null)}
                urlParams={{
                    plugin: 'Letters',
                    context: 'SponsorLetter',
                }}
                allowClearValue={false}
                autoLoadFirstId={true}
                required={true}
                onChange={this.setTemplateId.bind(this)}
            />
        );

        return (
            <div className="global-react-popup-wrapper">
                <div className={'global-react-popup add-content-item-version-note-popup popup-centered' + (this.state.visible ? ' visible' : '')}>
                    <i className="close" onClick={this._hide.bind(this)} />
                    <div className="content-wrapper">
                        <div className="content">
                            <div className="content-inner">
                                <h2 className="title">Preview Letter</h2>
                                <div className="form-holder">
                                    {templateField}
                                    <div className="form-actions">
                                        <a onClick={this._save.bind(this)} className='btn btn-primary save' role="button" style={{marginRight: 10}}>Preview</a>
                                        <a onClick={this._hide.bind(this)} className="btn btn-primary cancel" role="button">Cancel</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'global-react-popup-overlay  popup-centered' + (this.state.visible ? ' visible' : '')}/>
            </div>
        )
    }
}